export const Myprojects = [{
    title: "Template 1",
    desc: "Template 1 is a fully responsive website built using only HTML and CSS.",
    image: "./template1.png",
    category : "css",
    github: "https://github.com/AhmedDeV00/Reponsive-Website.git",
    live: "https://ahmeddev00.github.io/Reponsive-Website/"
},
{
    title: "Template 2",
    desc: "Template 2 is a modern and fully responsive website built using only HTML and CSS.",
    image: "./template2.png",
    category : "css",
    github: "https://github.com/AhmedDeV00/HTML-CSS-Template-2.git",
    live: "https://ahmeddev00.github.io/HTML-CSS-Template-2/"
},
{
    title: "Template 3",
    desc: "Template 3 is a sophisticated  and fully responsive website built using only HTML and CSS.",
    image: "./template3.png",
    category : "css",
    github: "https://github.com/AhmedDeV00/HTML-CSS-Template-3.git",
    live: "https://ahmeddev00.github.io/HTML-CSS-Template-3/"
},
{
    title: "Guess Word Game",
    desc: "This project is an interactive and fun Guess the Word game built using HTML, CSS, and JavaScript.",
    image: "./js.png",
    category : "javascript",
    github: "https://github.com/AhmedDeV00/Guess-Word-Game.git",
    live: "https://ahmeddev00.github.io/Guess-Word-Game/"
},
{
    title: "Calculator",
    desc: "This project is a simple, yet functional Calculator built with HTML, CSS, and JavaScript.",
    image: "./calcul.png",
    category : "javascript",
    github: "https://github.com/AhmedDeV00/Calculator.git",
    live: "https://ahmeddev00.github.io/Calculator/"
},
{
    title: "Portfolio",
    desc: "This project is a personal developer portfolio built with React. Designed to highlight your skills, projects, and experience.",
    image: "./port.png",
    category : "react",
    github: "https://github.com/AhmedDeV00/portfolio.git",
    live: "https://portfolio-liart-nine-18.vercel.app/"
},
{
    title: "php Crud Application",
    desc: "This project is a simple CRUD (Create, Read, Update, Delete) application built using PHP and MySQL.",
    image: "./php_crud.png",
    category : "phpMysql",
    github: "https://github.com/AhmedDeV00/php_crud.git",
    live: "http://tutorialphpcrud.infinityfreeapp.com"
},
{
    title: "Full Form Application",
    desc: "This project is a fully functional form submission system built using HTML, CSS, PHP and MySQL.",
    image: "./form.png",
    category : "phpMysql",
    github: "https://github.com/AhmedDeV00/Full_Form.git",
    live: "https://github.com/AhmedDeV00/Full_Form.git"
},
{
    title: "URL Shortener Application",
    desc: "This project is a dynamic URL Shortener application built using PHP, MySQL, JavaScript(Ajax), HTML, and CSS.",
    image: "./url.png",
    category : "phpMysql",
    github: "https://github.com/AhmedDeV00/URL-_Shortener.git",
    live: "http://URLshorten.wuaze.com"
},
{
    title: "E-commerce Website",
    desc: "This project is a modern and fully responsive E-commerce website built using the MERN stack (MongoDB, Express.js, React, Node.js).",
    image: "./eco.png",
    category : "mernStack",
    github: "https://github.com/AhmedDeV00/full_stack_ecommerce.git",
    live: ""
},
{
    title: "Travel Agency Website",
    desc: "This project is a full-stack travel agency website built with the MERN stack.",
    image: "./safari.png",
    category : "mernStack",
    github: "https://github.com/AhmedDeV00/Full-Stack-Travel-Tour-Website.git",
    live: ""
},
{
    title: "Social Media App",
    desc: "This project is a full-featured social media platform built with the MERN stack (Mysql, Express.js, React, Node.js).",
    image: "./social.png",
    category : "nodeMysql",
    github: "https://github.com/AhmedDeV00/Full-Stack-Social-Media-Website.git",
    live: ""
}
]